import { render } from "./MobileMenuChildItem.vue?vue&type=template&id=12d775f2"
import script from "./MobileMenuChildItem.vue?vue&type=script&lang=js"
export * from "./MobileMenuChildItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__